import "../accountingFilters.css";

const AccountingActiveFilters = ({ chips = [], onRemove, onClearAll }) => {
  if (!chips.length) return null;

  return (
    <div className="acc-active-filters">
      <span className="acc-active-filters-label">Đang lọc:</span>
      {chips.map((chip, idx) => (
        <span
          key={chip.key}
          className="acc-filter-chip"
          style={{ animationDelay: `${idx * 40}ms` }}
        >
          <span className="acc-filter-chip-label">{chip.label}:</span>
          <span className="acc-filter-chip-value">{chip.value}</span>
          {onRemove && (
            <button
              type="button"
              className="acc-filter-chip-remove"
              title={`Bỏ lọc ${chip.label}`}
              onClick={() => onRemove(chip.key)}
            >
              ×
            </button>
          )}
        </span>
      ))}
      {onClearAll && (
        <button type="button" className="acc-filter-clear-all btn btn-link p-0" onClick={onClearAll}>
          Xóa tất cả
        </button>
      )}
    </div>
  );
};

export default AccountingActiveFilters;
